import { Injectable } from '@angular/core';
import {
  IPagedItemsProceedResult,
  ServerSidePagedItemsProviderService,
  PagingApiMapperHelper,
} from '@core/data-providers';
import { Observable } from 'rxjs';
import { PatientsApiProviderService } from './api-providers/patients-api-provider.service';
import { map } from 'rxjs/operators';
import { EInvitationStatusDTO, IShortPatient } from '@project/view-models';
import { TGuid } from '@core/helpers';
import { EPatientStatusType } from '../../lazy-modules/patients/consts';

export interface IPatientFiltersParams {
  tag?: TGuid;
  search?: string;
  status?: EInvitationStatusDTO;
  statusPatient?: EPatientStatusType;
}

@Injectable({
  providedIn: 'root',
})
export class PatientServerSideItemsProviderService extends ServerSidePagedItemsProviderService<
  IShortPatient,
  IPatientFiltersParams,
  null
> {
  constructor(private patientsApiProviderService: PatientsApiProviderService) {
    super();
  }

  protected getDefaultFilters(): IPatientFiltersParams {
    return {};
  }

  protected proceedPagedItemsLoading(
    page,
    itemsPerPage,
    filtersState,
    sortingState,
  ): Observable<IPagedItemsProceedResult<IShortPatient>> {
    return this.patientsApiProviderService
      .getPagedWithShortData(page, itemsPerPage, this._filtersState$.value)
      .pipe(map((result) => PagingApiMapperHelper.mapPagingApiResponseToProceedResult<IShortPatient>(page, result)));
  }
}
